import { render, staticRenderFns } from "./fileItem.vue?vue&type=template&id=1e812c9a&scoped=true&"
import script from "./fileItem.vue?vue&type=script&lang=js&"
export * from "./fileItem.vue?vue&type=script&lang=js&"
import style0 from "./fileItem.vue?vue&type=style&index=0&lang=css&"
import style1 from "./fileItem.vue?vue&type=style&index=1&id=1e812c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e812c9a",
  null
  
)

component.options.__file = "fileItem.vue"
export default component.exports